import React, { useEffect, useState, useRef } from 'react';
import API from '../../../services/api';
import Tags from '../../../components/tags';
import CampaignSelector from '../../../components/campaignSelector';

const PortalCampaigns = ({ portal }) => {
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [reload, setReload] = useState('');

  const fetchAllPromise = useRef(null);

  useEffect(() => {
    if (portal) {
      setFilteredCampaigns([]);
      fetchAllCampaigns();
    } else {
      setFilteredCampaigns([]);
    }
  }, [portal]);

  const fetchAllCampaigns = () => {
    if (!portal || !portal.companyId) {
      return Promise.resolve({ nextPageToken: '', totalSize: 0 });
    }

    if (fetchAllPromise.current) return fetchAllPromise.current;

    const p = (async () => {
      try {
        const portalFilter = encodeURI(`brandPortalId = "${portal.id}"`);
        let token = '';
        let all = [];
        let totalSizeFromApi = 0;

        do {
          const res = await API.getCampaigns(portal.companyId, token, portalFilter);
          if (res && res.totalSize) {
            totalSizeFromApi = res.totalSize;
          }
          const fetched = (res.campaigns || []).map(c => ({ ...c, id: c.id.trim() }));
          all = [...all, ...fetched];
          token = res.nextPageToken || '';
        } while (token);

        setFilteredCampaigns(all);

        return { nextPageToken: '', totalSize: totalSizeFromApi || all.length };
      } finally {
        fetchAllPromise.current = null;
      }
    })();

    fetchAllPromise.current = p;
    return p;
  };

  const handleCampaignSelect = campaign => {
    if (!campaign) return;
    const exists = filteredCampaigns.some(c => c.id === campaign.id);
    if (!exists) {
      API.updateCampaign(portal.companyId, campaign.id, { ...campaign, brandPortalId: portal.id }, [
        'brandPortalId'
      ]).then(() => {
        setReload(new Date().toString());
        setFilteredCampaigns([...filteredCampaigns, campaign]);
      });
    } else {
      setFilteredCampaigns(filteredCampaigns.filter(c => c.id !== campaign.id));
    }
  };

  const handleRemoveCampaign = campaign => {
    if (!campaign) return;
    API.updateCampaign(portal.companyId, campaign.id, { ...campaign, brandPortalId: '' }, ['brandPortalId']).then(
      () => {
        setReload(new Date().toString());
        setFilteredCampaigns(filteredCampaigns.filter(c => c.id !== campaign.id));
      }
    );
  };

  return (
    <>
      <div className="form-group site-device-section">
        <label>Campaings</label>
        <CampaignSelector
          company={portal?.companyId}
          onSelection={handleCampaignSelect}
          reload={reload}
          customLabel={null}
        />
      </div>
      <div className="site-tags">
        {filteredCampaigns.map(tag => {
          return (
            <Tags
              key={`tag-${tag.displayName.trim().toLowerCase().replace(/\s+/g, '-')}`}
              value={tag.displayName || tag.id}
              hasCloseButton
              onClose={() => handleRemoveCampaign(tag)}
            />
          );
        })}
      </div>
    </>
  );
};

export default PortalCampaigns;
